import React from 'react'

export default function Footer() {
    return (
        <div className="footer">
           <footer class="py-0 bg-dark fixed-bottom">
        <div class="container">
          <p class="m-0 text-center text-white">
            Copyright &copy; Your Health is Our Wealth
          </p>
        </div>
      </footer> 
        </div>
    )
}
